import React from 'react';
import BalanceGridRow from '../types';
import { Button } from 'semantic-ui-react';
import { CustomCellRendererProps } from 'ag-grid-react';

interface Props extends CustomCellRendererProps {
  data: BalanceGridRow;
  remove: (accountId: string) => void;
}

const RemoveLedgerRenderer = ({ data, remove }: Props) =>
  data?.accountId ? (
    <Button
      className="link"
      content="Remove"
      onClick={() => remove(data.accountId)}
    />
  ) : null;

export default RemoveLedgerRenderer;
